import { getFragmentData } from "@/__generated__";
import type {
  ClientApplyVoucherMutation,
  ClientApplyVoucherMutationVariables,
} from "@/__generated__/graphql";
import {
  ClientApplyVoucherDocument,
  InvoiceDetailFragmentFragmentDoc,
  InvoicesByFiltersDocument,
} from "@/__generated__/graphql";
import { showToast } from "@/components/ui/toast/show-toast";
import type { InvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";
import { getInvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";
import { ClientInstance } from "@/lib/graphql/apollo";
import { createRequestFactory } from "@/lib/request-factory";

import { useInvoiceDetailStore } from "./invoiceDetail";
import { useAvailableClientVouchersStore } from "./useAvailableClientVouchers";

export const useApplyVoucherInvoiceStore = createRequestFactory<
  ClientApplyVoucherMutation,
  InvoiceDetailData,
  ClientApplyVoucherMutationVariables
>({
  method: "mutation",
  graphqlDocument: ClientApplyVoucherDocument,
  transformFunction(data) {
    if (!data.clientApplyVoucher?.invoice) {
      throw new Error("Invoice not found");
    }
    const invoice = getFragmentData(
      InvoiceDetailFragmentFragmentDoc,
      data.clientApplyVoucher.invoice,
    );
    return getInvoiceDetailData(invoice);
  },
  onFetchSuccess() {
    useInvoiceDetailStore.getState().refetch();
    useAvailableClientVouchersStore.getState().refetch();
    ClientInstance.refetchQueries({ include: [InvoicesByFiltersDocument] });
    showToast({
      title: "Voucher applied successfully",
      type: "success",
    });
  },
});
